/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2023 
	27-03-2023
	- [CHANGE] The mobile Fix: 100% Height mobile was not good enough, it's better now.
2018
	08-03-2019
	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_interactions_window = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	// none

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/**
	Window: resize
	**/
	this.windowResize = function (scrolled, h, w) {

		/*
		Set: Variables
		*/
		if (typeof h === 'undefined') {
			h = $(window).height();
		}
		if (typeof w === 'undefined') {
			w = $(window).width();
		}

		/*
		Fix: 100% Height mobile
		*/
		document.querySelector(':root').style.setProperty('--vh', window.innerHeight + 'px');

		/*
		Desktop: Always close mobilemenu
		*/
		specific_mobilemenu.close();

	};

	/**
	Window: scroll
	**/
	this.windowScroll = function (scrolled, h, w) {

		/*
		Back to top
		*/
		$('.js-back-to-top').find('.icon').css({
			'transform': 'rotate(' + (scrolled / 3) + 'deg)'
		});

		/*
		Animate on scroll
		*/
		if (scrolled >= 100) {

			if (_fixed_shown == 0) {

				$('header').stop().animate({
					'top': -($('header').outerHeight() + 50)
				}, 400, function () {
					$('header').show();
				});

				/*
				Show: Footer Up
				*/
				$('.js-back-to-top').stop().animate({
					'bottom': '3vw'
				}, 600);

				// $('.js-logo').stop().animate({
				// 	'top':-200
				// },400);

				// $('.js-menu-fixed').stop().animate({
				// 	'top':-200
				// },400);

				_fixed_shown = 1;

			}

		} else {

			if (_fixed_shown == 1) {

				$('header').stop().animate({
					'top': 0
				}, 400, function () {
					$('header').show();
				});

				/*
				Show: Footer Up
				*/
				$('.js-back-to-top').stop().animate({
					'bottom': '-15vw'
				}, 600);

				// $('.js-logo').stop().animate({
				// 	'top':40
				// },400);

				// $('.js-menu-fixed').stop().animate({
				// 	'top':0
				// },400);

				_fixed_shown = 0;

			}

		}

		/*
		Projects
		*/
		_animation_counter = 1;
		$('.js-fade-inonscroll').each(function () {

			/*
			Marge
			*/
			var _marge;
			if (w < 400) {
				_marge = (h + 100);
			} else {
				_marge = (h + 250);
			}

			if (scrolled > $(this).offset().top - _marge) {

				if (_animation_counter > 2) {

					/*
					Random: 3 or 4
					*/
					var _random = Math.floor(Math.random() * 2) + 3;

					$(this).addClass('animated-' + _random);

				} else {
					$(this).addClass('animated-' + _animation_counter);
				}

			}

			_animation_counter++;

		});

	};

	/**
	Window: orientation
	**/
	this.windowOrientationChange = function () {

	};

}).apply(specific_interactions_window); 